<template>
 <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css" integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous"/>


  <div id = "inetProvidersCompare-container">
    <label class="block-caption" :style="{ color: widgetSettingsData.inputLabelColor, background: widgetSettingsData.inputLabelBackgroundColor}">Se alle bredbåndstilbud til din adresse </label>
      <div class="autocomplete-container">
        <input 
          type = "search" 
          id="dawaautocompleteinput"
          placeholder="Indtast din adresse"
          v-model="userAdress"
          @input="inputChanged"
          @blur="inputChanged"
          :class="{ 'inputError':adressError}"
           class = "inputfield"
           :style="{'border-color':widgetSettingsData.inputfieldBorderColor, 
      background:widgetSettingsData.inputfieldBackgroundColor}"
        > 
        <div class = "inetProvidersCompare-button" @click="followUrl" :style = "{ color: widgetSettingsData.summarybuttonTextColor, background:widgetSettingsData.summarybuttonColor}">{{buttontext}}</div>
      </div>
      <p :class="{ 'adressError':adressError, 'adressOk':adressOk}" >Indtast den fulde adresse tak</p>
      <label :style="{ color: widgetSettingsData.inputLabelColor, background: widgetSettingsData.inputLabelBackgroundColor}">Hvorfor har vi brug for din adresse?
        <i class="fa fa-question-circle question-tooltip" aria-hidden="true" data-toggle="tooltip" title="Vi vil ikke vise dig en masse tilbud, du alligevel ikke kan få, så ved at give os din adresse, viser vi kun tilbud, som faktisk er mulige at få på din adresse.">
        </i>
      </label>
  </div>
</template>




<script>
var addressData = {}
let requestCount = 0

export default {
  name: 'inetProvidersCompare',
  data(){
    return{
    widgetSettingsData:{
      widgetheading:"test caption",
      inputLabelText:"label text",
      sliderColor:"red",
      headingon:true,
    }//widgetSettingsData
    ,
    buttontext:"button",
    addressData:addressData,
    requestCount:requestCount,
    adressError:false,
    adressOk:true
    }
  },
  mounted() {
  // Get attribute inside widgets-editor
  if(window.frameElement !== null && window.frameElement.getAttribute('data-headingStyleOptions') !== null){
    let iframeConfigData = JSON.parse( window.frameElement.getAttribute('data-headingStyleOptions') );
    this.widgetSettingsData = iframeConfigData;
  }
  // Adding event-listners
  this.$nextTick(function() {
    window.addEventListener('storage', this.applySettingsFromLocalStorage);
    window.addEventListener('message', this.receiveDatafromIframe);
  });//nextTick

    if(requestCount == 0){
    var dawaAutocomplete2 = require('dawa-autocomplete2');
    var inputElm = document.getElementById('dawaautocompleteinput');
    
    dawaAutocomplete2.dawaAutocomplete(inputElm, 
      {
        select:function(selected)
        {
        addressData = selected
        requestCount = 1
        }
      });//component
}
  },
  methods: {
  receiveDatafromIframe(event){
  if(event.data.loaded ==="yes"){
    this.widgetSettingsData = event.data;
    document.body.style.setProperty('--slidercolor', this.widgetSettingsData.sliderColor);
    this.buttontext = this.widgetSettingsData.summarybuttonText;
    this.widgetSettingsData.headingTextColor=event.data.headingTextColor;
    if(event.data.headingon === "false"){
    this.widgetSettingsData.headingon = false;
    }
  }
},
  applySettingsFromLocalStorage(){ 
    if(window.localStorage.getItem("headingtext") !== null){
      this.widgetSettingsData = JSON.parse(window.localStorage.getItem("headingtext") );
      document.body.style.setProperty('--slidercolor', this.widgetSettingsData.sliderColor);
      this.buttontext = this.widgetSettingsData.summarybuttonText;
      }
    },//applySettingsFromLocalStorage
    followUrl:function(){
      let staticUrl = "https://www.samlino.dk/bredbaand/hjemme/resultater?"
      let prefix = ""
      let suffix = "_______"
      if(typeof(addressData.tekst) != "undefined" && typeof(this.userAdress) != "undefined"  && this.userAdress != "" ){
        this.adressError=false;
        this.adressOk=true;
      
      for(var g=0; g<(4-addressData.data.husnr.length); g++){
        prefix += "_"
      }

    let utmparams = "";
    let followedUrl = "";
    
    var source = "";
    var medium = "";
    var campaign = "";
 
            if(this.widgetSettingsData.source == "" || typeof(this.widgetSettingsData.source) === "undefined"){
              source = "iframe";
            }else{
              source = this.widgetSettingsData.source;
            }

            if(this.widgetSettingsData.medium == "" || typeof(this.widgetSettingsData.medium) === "undefined"){
              medium = "referral"
            }else{
              medium = this.widgetSettingsData.medium;
            }

            if( this.widgetSettingsData.campaign == "" || typeof(this.widgetSettingsData.campaign) === "undefined"){
              campaign = "default";
            }else{
              campaign = this.widgetSettingsData.campaign;
            }
            
            utmparams = "utm_source=" + source + "&"
            + "utm_medium=" + medium + "&"
            + "utm_campaign=" + campaign;
     
      followedUrl = staticUrl 
      + "address=" + addressData.tekst 
      + "&" 
      + "addressId=" + addressData.data.id
      + "&"
      + "kvhx=" + addressData.data.kommunekode + addressData.data.vejkode + prefix + addressData.data.husnr + suffix
      + "&"
      + "kvh=" + addressData.data.kommunekode + addressData.data.vejkode + prefix + addressData.data.husnr
      + "&"
      + "zip=" + addressData.data.postnr
      + "&"
      + "postcode=" + addressData.data.postnr
      + "&"
      + "city=" + addressData.data.postnrnavn
      + "&"
      + "streetnumber=" + addressData.data.husnr
      + "&"
      + "streetname=" + addressData.data.vejnavn
      + "&"
      + "floor=" + addressData.data.etage
      + "&"
      + utmparams; 
      
      window.open(followedUrl, '_blank');
      }// if address data > 0
      else{
        this.adressError=true;
        this.adressOk=false;
      }
    },//followUrl
    inputChanged:function(){
      this.userAdress=addressData.tekst;
      if(typeof(addressData.tekst) != "undefined" && typeof(this.userAdress) != "undefined"  && this.userAdress != ""){
        this.adressError=false;
        this.adressOk=true;
      }
      else{
        this.adressError=true;
        this.adressOk=false;
      }
    }//inputChanged
  },//methods
}//default

</script>


<style>


.noErrors{
  border-color:green !important;
}

.inputError{
  border-color:red !important;
}

.adressError{
  display: block;
  color:red;
  font-weight: bold;
  text-align: left;
}

.adressOk{
  display:none;
  text-align: left;
}


#inetProvidersCompare-container{
  display: inline-block;
  width:96%;
  margin-left:2%;
  margin-right:2%;
  background: white;
}

.block-caption{
  width:100%;
  text-align:left;
  font-weight:bold;
  padding-top:5px;
  padding-bottom:7px;
}

.autocomplete-container{
  display: flex;
  margin:0;
  padding:0;
  width:100%;
  height:56px;
}

.inputfield{
  -webkit-appearance: none !important;
  -moz-appearance: none;
  padding:0;
  margin:0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  float:left;
  border-style:none;
  width: 75.0%;
  height:auto;
      border-width:1px;
      border-style:solid;
      border-radius: 3px;
      border-color:grey;
        font-size: 16px;
        line-height: 25px;
        color:rgb(49, 47, 43);
        padding-left:10px;  
}

.inetProvidersCompare-button{
  display: flex;
  padding:0;
  margin:0;
  width: 19.0%;
  color:white;
  background: #f58423;
    border:none;
    border-radius:3px;
    text-align:center;
    padding-top:15px ;
    justify-content: center;
    margin-left:1.4%;
    font-family:proxima-nova, "Helvetica Neue", Helvetica, "Microsoft JhengHei", "Open Sans", Arial, sans-serif;
    font-size: 16px;
    font-weight:900;
    line-height: 24px;
    box-shadow: 0 4px 16px rgba(0,0,0,.2);
    -moz-box-shadow: 0 2px 4px rgba(0,0,0,.1);
    -webkit-box-shadow: 0 4px 16px rgba(0,0,0,.2);
}

.inetProvidersCompare-button:hover{
  cursor: pointer;
  }


#inetProvidersCompare-container label{
  display: block;
  float:left;
  padding-top:10px;
  padding-bottom:5px;
  text-align: left;
}

#inetProvidersCompare-container label i{
  margin-left:10px;
  color: #979290;
  font-size:14px;
}

#inetProvidersCompare-container label i:hover{
cursor: help;
}


.p-tooltip-text{
  background: #f3f2ee !important;
  border-style:solid;
  border-color:#979290;
  color: #353332 !important;
  width:212px;
      font-style: normal;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 120%;
    color: #312f2e;
}



/* DAWA Styling */ 
.autocomplete-container {
    /* relative position for at de absolut positionerede forslag får korrekt placering.*/
    position: relative;
    width: 100%;
    max-width: 30em;
}

.autocomplete-container input {
    /* Både input og forslag får samme bredde som omkringliggende DIV */
    width: 100%;
    box-sizing: border-box;
}

.dawa-autocomplete-suggestions {
    margin: 0.3em 0 0 0;
    padding: 0;
    text-align: left;
    border-radius: 0.3125em;
    background: #fcfcfc;
     box-shadow: 0 0.0625em 0.15625em rgba(0,0,0,.15);
    -moz-box-shadow: 0 0.03em 0.7em rgba(0,0,0,.07);
    -webkit-box-shadow: 0 0.0625em 0.15625em rgba(0,0,0,.15);
    position: absolute;
    left: 0;
    right: 0;
    z-index: 9999;
    overflow-y: auto;
    box-sizing: border-box;
    margin-top:60px;
    height: 150px;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
    margin: 0;
    list-style: none;
    cursor: pointer;
    padding: 0.4em 0.6em;
    color: #333;
    border: 0.0625em solid #ddd;
    border-bottom-width: 0;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:last-child {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    border-bottom-width: 0.0625em;
}

.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion.dawa-selected,
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:hover {
    background: #f0f0f0;
}


@media screen and (max-width: 380px) /* Mobile */ {
.inetProvidersCompare-button{
  font-size:12px;
}

#inetProvidersCompare-container label{
  text-align: left;
}

  }/* @media screen and (max-width: 350px) */


@media screen and (max-width: 320px) /* Mobile */ {
.inetProvidersCompare-button{
  font-size:8px;
}

#inetProvidersCompare-container label{
  text-align: left;
}

  }/* @media screen and (max-width: 270px) */

  
</style>